// ============================================================================
// Activities API — provenance-tagged exercises (Wave 1).
// ----------------------------------------------------------------------------
// TRAINER surface (`/api/activities*`): list an owned client's activities, the
// all-clients calendar feed (drives the activity layer of the trainer calendar
// merge), suggest homework (source forced to 'suggested' server-side), patch a
// suggestion, delete one. CLIENT self-service lives in api/client.ts.
// ============================================================================
import { http } from "./http";
import type {
  Activity,
  ActivityInput,
  CalendarActivity,
  OkResponse,
} from "./types";

export interface ActivityCalendarRange {
  start?: string;
  end?: string;
  // Index signature keeps this assignable to the http `Query` param type.
  [key: string]: string | undefined;
}

export const activitiesApi = {
  /** All activities for an owned client (`?client_id=` required). */
  listForClient: (clientId: number, signal?: AbortSignal) =>
    http.get<Activity[]>("/activities", { client_id: String(clientId) }, signal),

  /** All of THIS trainer's activities (across every client) for the calendar merge. */
  calendar: (range: ActivityCalendarRange = {}, signal?: AbortSignal) =>
    http.get<CalendarActivity[]>("/activities/calendar", range, signal),

  /** Suggest homework for an owned client (provenance forced to 'suggested'). */
  suggest: (clientId: number, body: ActivityInput) =>
    http.post<Activity>("/activities", body, { client_id: clientId }),

  update: (activityId: number, body: ActivityInput) =>
    http.patch<Activity>(`/activities/${activityId}`, body),

  remove: (activityId: number) =>
    http.del<OkResponse>(`/activities/${activityId}`),
};
